// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__03ewt","focado":"OptionSelect_focado__Rl1rQ"};